export const translations = {
  en: {
    languageName: "English",
    languageShort: "EN",
    nav: { label: "Portfolio navigation", home: "Home", about: "About", apps: "Apps", projects: "Projects", contact: "Contact" },
    intro: {
      kicker: "Web and mobile product developer",
      greeting: "Hello, my name is",
      name: "Uladzimir Aliakhnovich",
      titleItems: [
        "Android App Developer",
        "React Developer",
        "Mobile UX Builder",
        "iPhone Release Planning",
        "Product-Minded Creator",
      ],
      description:
        "I build responsive websites and mobile applications with a focus on simple interfaces, useful details and products that can actually ship.",
      availability: "Open for new web projects",
      contactButton: "Discuss a project",
      workButton: "View work",
      stats: [
        { value: "1", label: "Android app live" },
        { value: "3", label: "mobile products" },
        { value: "iOS", label: "next target" },
      ],
      floatingGoogle: "Google Play",
      floatingBuilding: "Now building",
      highlightsLabel: "Portfolio highlights",
    },
    about: {
      title: "About me",
      subtitle:
        "I continue to work on web development while also building mobile products for Android, with iPhone releases as the next step.",
      description:
        "I work across modern web and mobile development: responsive React interfaces, React Native / Expo applications for Android, and the practical path from implementation to deployment and Google Play release.",
      skillGroups: [
        { label: "Web", items: ["JavaScript", "React", "HTML / CSS", "Sass", "Redux"] },
        { label: "Mobile", items: ["React Native", "Expo", "Android", "Google Play"] },
        { label: "Tools", items: ["Git", "Figma", "Vercel"] },
      ],
      awardTitle: "TeachMeSkills frontend developer course",
      awardDescription:
        "This course gave me a strong start in web development. Since then I have kept building, improving and turning learning into shipped products.",
    },
    mobileApps: {
      kicker: "Mobile development",
      title: "Mobile products",
      description:
        "My Android apps for travel, photo albums and multilingual WhatsApp communication. My Route is available on Google Play; My PhotoBook and MyChatSense are being tested.",
      tabsLabel: "Mobile apps",
      previewLabel: "preview",
      liveBuild: "Live build",
      storeButton: "Google Play",
      contactButton: "Discuss mobile work",
      privacyButton: "Privacy policy",
      items: {
        "my-route": {
          status: "Live on Google Play",
          platform: "Android",
          summary:
            "A travel, route-planning and city-exploration app for building walking routes, saving trips and keeping travel memories.",
          features: ["maps and routes", "city discovery", "local travel album"],
          screenTitle: "Valencia walk",
          screenMeta: "4 places  2.8 km",
        },
        "my-photobook": {
          status: "Closed testing on Google Play",
          platform: "Android",
          summary:
            "A mobile photobook maker for albums, captions, printable layouts and PDF export that keeps user content local.",
          features: ["photo albums", "PDF export", "print layouts"],
          screenTitle: "Summer album",
          screenMeta: "24 photos  PDF ready",
        },
        "my-chatsense": {
          status: "Internal testing on Google Play",
          platform: "Android",
          summary:
            "An Android companion for selected WhatsApp chats that translates incoming messages and helps prepare replies in the other person's language.",
          features: ["WhatsApp chat translation", "voice transcription", "11 languages"],
          screenTitle: "Translated chat",
          screenMeta: "11 languages  voice input",
        },
      },
    },
    projects: {
      kicker: "Web development",
      title: "Web projects",
      description:
        "Published and current web work comes first, followed by a compact archive of earlier front-end projects.",
      currentKicker: "In progress",
      currentTitle: "Currently building",
      currentDescription:
        "KeyLab is still in development, so it is shown here as active work rather than a released website.",
      webKicker: "Selected web work",
      webTitle: "Diploma project",
      webDescription:
        "A larger web project from my front-end training, kept separate from the smaller learning exercises.",
      completedTitle: "Completed projects",
      archiveKicker: "Learning archive",
      archiveTitle: "Early web projects",
      archiveDescription:
        "Smaller course projects that show the foundation I started from: layout, responsive pages and JavaScript practice.",
      diplomaLabel: "Diploma project",
      openProject: "Open project",
      viewCodeGithub: "View code on GitHub",
      items: {
        2: { description: "Diploma project: an online store for rhythmic gymnastics products." },
        3: { description: "Marketplace interface experiment with product filtering." },
        4: { description: "Responsive food delivery website with a bright visual style." },
        5: { description: "Pixel-focused webpage layout and adaptive presentation." },
        6: { description: "Nature-themed page with careful desktop and mobile layout." },
        9: {
          status: "Published website",
          tag: "Learning platform",
          description: "A published learning platform for structured Spanish and English courses from A0 to C1.",
          features: ["Spanish & English", "A0–C1 levels", "interactive lessons"],
        },
        11: {
          status: "Published website",
          tag: "Travel agency",
          description: "A multilingual website for a travel agency, presenting services, destinations and personalized trip planning in Spanish, Russian and English.",
          features: ["Spanish, Russian & English", "responsive website", "light & dark themes"],
        },
        12: {
          status: "Published website",
          tag: "Music platform",
          description: "The official IDNT music platform with releases, track playback and information about the artist.",
        },
        10: {
          status: "In development",
          tag: "Automotive website",
          description: "A business website for an automotive electronics workshop working with keys, immobilizers and electronic control units.",
          features: ["automotive electronics", "keys & immobilizers", "service website"],
        },
      },
    },
    contact: {
      cta: {
        kicker: "Have a website idea?",
        title: "From idea to launch",
        description:
          "I am open to new web projects. I can help shape the structure, build a responsive website, prepare it for publication, connect the domain and handle the basic SEO setup. A detailed technical brief is not required to start — describe the idea briefly in the form below.",
        button: "Discuss your project",
        servicesLabel: "Web development services",
        services: [
          "Structure and responsive development",
          "Domain setup and publication",
          "Basic SEO and launch preparation",
        ],
      },
      kicker: "Contact",
      title: "Tell me about your project",
      descriptionLead: "Describe the idea briefly.",
      description:
        "Use the form to tell me what you want to build, what the website should do and any requirements you already have.",
      placeholders: {
        name: "Name",
        subject: "Subject",
        email: "Email",
        message: "Message",
      },
      submit: "Submit",
      sending: "Sending...",
      success: "Thank you...",
      error: "Message was not sent. Check console for details.",
    },
  },
  es: {
    languageName: "Español",
    languageShort: "ES",
    nav: { label: "Navegación del portfolio", home: "Inicio", about: "Sobre mí", apps: "Apps", projects: "Proyectos", contact: "Contacto" },
    intro: {
      kicker: "Desarrollador web y de productos móviles",
      greeting: "Hola, me llamo",
      name: "Uladzimir Aliakhnovich",
      titleItems: [
        "Desarrollador Android",
        "Desarrollador React",
        "Creador de UX móvil",
        "Próximamente iOS",
        "Creador con visión de producto",
      ],
      description:
        "Creo sitios web responsive y aplicaciones móviles con foco en interfaces simples, detalles útiles y productos que pueden publicarse de verdad.",
      availability: "Disponible para nuevos proyectos web",
      contactButton: "Hablar de un proyecto",
      workButton: "Ver trabajos",
      stats: [
        { value: "1", label: "app Android publicada" },
        { value: "3", label: "productos móviles" },
        { value: "iOS", label: "siguiente objetivo" },
      ],
      floatingGoogle: "Google Play",
      floatingBuilding: "En desarrollo",
      highlightsLabel: "Puntos clave del portfolio",
    },
    about: {
      title: "Sobre mí",
      subtitle:
        "Sigo trabajando en desarrollo web y, al mismo tiempo, desarrollo productos móviles para Android; el siguiente paso son los lanzamientos para iPhone.",
      description:
        "Trabajo tanto en desarrollo web moderno como móvil: interfaces responsive con React, aplicaciones Android con React Native / Expo y todo el recorrido práctico desde la implementación hasta el despliegue y la publicación en Google Play.",
      skillGroups: [
        { label: "Web", items: ["JavaScript", "React", "HTML / CSS", "Sass", "Redux"] },
        { label: "Mobile", items: ["React Native", "Expo", "Android", "Google Play"] },
        { label: "Herramientas", items: ["Git", "Figma", "Vercel"] },
      ],
      awardTitle: "Curso de desarrollador frontend en TeachMeSkills",
      awardDescription:
        "Este curso me dio una base sólida en desarrollo web. Desde entonces he seguido construyendo, mejorando y convirtiendo el aprendizaje en productos publicados.",
    },
    mobileApps: {
      kicker: "Desarrollo móvil",
      title: "Productos móviles",
      description:
        "Mis aplicaciones Android para viajes, fotolibros y comunicación multilingüe en WhatsApp. My Route está en Google Play; My PhotoBook y MyChatSense están en fase de pruebas.",
      tabsLabel: "Apps móviles",
      previewLabel: "vista previa",
      liveBuild: "Versión activa",
      storeButton: "Google Play",
      contactButton: "Hablar de una app",
      privacyButton: "Política de privacidad",
      items: {
        "my-route": {
          status: "Disponible en Google Play",
          platform: "Android",
          summary:
            "Una app de viajes, planificación de rutas y exploración urbana para crear recorridos a pie, guardar viajes y conservar recuerdos.",
          features: ["mapas y rutas", "descubrir ciudades", "álbum local de viaje"],
          screenTitle: "Paseo por Valencia",
          screenMeta: "4 lugares  2.8 km",
        },
        "my-photobook": {
          status: "Pruebas cerradas en Google Play",
          platform: "Android",
          summary:
            "Una app para crear fotolibros móviles con álbumes, textos, diseños imprimibles y exportación a PDF, manteniendo el contenido local.",
          features: ["álbumes de fotos", "exportación PDF", "diseños imprimibles"],
          screenTitle: "Álbum de verano",
          screenMeta: "24 fotos  PDF listo",
        },
        "my-chatsense": {
          status: "Pruebas internas en Google Play",
          platform: "Android",
          summary:
            "Una app Android para chats seleccionados de WhatsApp que traduce los mensajes recibidos y ayuda a preparar respuestas en el idioma del interlocutor.",
          features: ["traducción de chats de WhatsApp", "transcripción de voz", "11 idiomas"],
          screenTitle: "Chat traducido",
          screenMeta: "11 idiomas  entrada por voz",
        },
      },
    },
    projects: {
      kicker: "Desarrollo web",
      title: "Proyectos web",
      description:
        "Primero aparecen los trabajos web publicados y actuales; después, un archivo compacto de proyectos front-end anteriores.",
      currentKicker: "En desarrollo",
      currentTitle: "Proyectos actuales",
      currentDescription:
        "KeyLab sigue en desarrollo, por eso aparece aquí como trabajo activo y no como un sitio ya publicado.",
      webKicker: "Trabajo web seleccionado",
      webTitle: "Proyecto final",
      webDescription:
        "Un proyecto web más amplio de mi formación front-end, separado de los ejercicios de aprendizaje más pequeños.",
      completedTitle: "Proyectos terminados",
      archiveKicker: "Archivo de aprendizaje",
      archiveTitle: "Primeros proyectos web",
      archiveDescription:
        "Proyectos de curso más pequeños que muestran la base con la que empecé: maquetación, páginas responsive y práctica de JavaScript.",
      diplomaLabel: "Proyecto final",
      openProject: "Abrir proyecto",
      viewCodeGithub: "Ver código en GitHub",
      items: {
        2: { description: "Proyecto final: tienda online de productos para gimnasia rítmica." },
        3: { description: "Experimento de marketplace con filtrado de productos." },
        4: { description: "Sitio responsive de comida a domicilio con estilo visual vivo." },
        5: { description: "Maquetación web cuidada con presentación adaptativa." },
        6: { description: "Página con temática de naturaleza y diseño adaptado a móvil y escritorio." },
        9: {
          status: "Sitio publicado",
          tag: "Plataforma educativa",
          description: "Una plataforma publicada para aprender español e inglés de forma estructurada desde A0 hasta C1.",
          features: ["español e inglés", "niveles A0–C1", "lecciones interactivas"],
        },
        11: {
          status: "Sitio publicado",
          tag: "Agencia de viajes",
          description: "Sitio multilingüe para una agencia de viajes que presenta servicios, destinos y planificación personalizada en español, ruso e inglés.",
          features: ["español, ruso e inglés", "sitio responsive", "tema claro y oscuro"],
        },
        12: {
          status: "Sitio publicado",
          tag: "Plataforma musical",
          description: "La plataforma musical oficial de IDNT con lanzamientos, reproducción de canciones e información sobre el artista.",
        },
        10: {
          status: "En desarrollo",
          tag: "Web de automoción",
          description: "Sitio web para un taller de electrónica del automóvil especializado en llaves, inmovilizadores y unidades electrónicas.",
          features: ["electrónica del automóvil", "llaves e inmovilizadores", "web de servicios"],
        },
      },
    },
    contact: {
      cta: {
        kicker: "¿Tienes una idea para una web?",
        title: "De la idea al lanzamiento",
        description:
          "Estoy disponible para nuevos proyectos web. Puedo ayudarte a definir la estructura, desarrollar un sitio responsive, prepararlo para su publicación, conectar el dominio y realizar una configuración SEO básica. No necesitas un documento técnico completo: describe brevemente la idea en el formulario de abajo.",
        button: "Hablar de tu proyecto",
        servicesLabel: "Servicios de desarrollo web",
        services: [
          "Estructura y desarrollo responsive",
          "Dominio y publicación",
          "SEO básico y preparación del lanzamiento",
        ],
      },
      kicker: "Contacto",
      title: "Cuéntame tu proyecto",
      descriptionLead: "Describe brevemente la idea.",
      description:
        "Usa el formulario para contarme qué quieres crear, qué debería hacer el sitio y qué requisitos ya tienes definidos.",
      placeholders: {
        name: "Nombre",
        subject: "Asunto",
        email: "Email",
        message: "Mensaje",
      },
      submit: "Enviar",
      sending: "Enviando...",
      success: "Gracias...",
      error: "El mensaje no se envió. Revisa la consola para más detalles.",
    },
  },
  ru: {
    languageName: "Русский",
    languageShort: "RU",
    nav: { label: "Навигация по портфолио", home: "Главная", about: "Обо мне", apps: "Приложения", projects: "Проекты", contact: "Контакты" },
    intro: {
      kicker: "Разработчик web и мобильных продуктов",
      greeting: "Привет, меня зовут",
      name: "Владимир Алехнович",
      titleItems: [
        "Android-разработчик",
        "React-разработчик",
        "Создатель мобильного UX",
        "Готовлю релизы для iPhone",
        "Разработчик с продуктовым мышлением",
      ],
      description:
        "Я создаю адаптивные сайты и мобильные приложения с фокусом на простые интерфейсы, полезные детали и продукты, которые можно довести до релиза.",
      availability: "Открыт к новым web-проектам",
      contactButton: "Обсудить проект",
      workButton: "Смотреть работы",
      stats: [
        { value: "1", label: "Android-приложение опубликовано" },
        { value: "3", label: "мобильных продукта" },
        { value: "iOS", label: "следующая цель" },
      ],
      floatingGoogle: "Google Play",
      floatingBuilding: "В разработке",
      highlightsLabel: "Главные акценты портфолио",
    },
    about: {
      title: "Обо мне",
      subtitle:
        "Я продолжаю заниматься web-разработкой и параллельно развиваю мобильные продукты для Android; следующим шагом планирую релизы для iPhone.",
      description:
        "Работаю и с современным web, и с мобильной разработкой: создаю адаптивные интерфейсы на React, Android-приложения на React Native / Expo и прохожу практический путь от реализации до публикации web-проектов и релиза в Google Play.",
      skillGroups: [
        { label: "Web", items: ["JavaScript", "React", "HTML / CSS", "Sass", "Redux"] },
        { label: "Mobile", items: ["React Native", "Expo", "Android", "Google Play"] },
        { label: "Инструменты", items: ["Git", "Figma", "Vercel"] },
      ],
      awardTitle: "Курс frontend-разработчика TeachMeSkills",
      awardDescription:
        "Этот курс дал мне хороший старт в веб-разработке. С тех пор я продолжаю строить, улучшать и превращать обучение в опубликованные продукты.",
    },
    mobileApps: {
      kicker: "Мобильная разработка",
      title: "Мобильные продукты",
      description:
        "Мои Android-приложения для путешествий, фотокниг и многоязычного общения в WhatsApp. My Route опубликован в Google Play, My PhotoBook и MyChatSense проходят тестирование.",
      tabsLabel: "Мобильные приложения",
      previewLabel: "превью",
      liveBuild: "Живая версия",
      storeButton: "Google Play",
      contactButton: "Обсудить приложение",
      privacyButton: "Политика конфиденциальности",
      items: {
        "my-route": {
          status: "Опубликовано в Google Play",
          platform: "Android",
          summary:
            "Приложение для путешествий, маршрутов и исследования городов: пешие маршруты, сохраненные поездки и дорожные воспоминания.",
          features: ["карты и маршруты", "исследование городов", "локальный альбом"],
          screenTitle: "Прогулка по Валенсии",
          screenMeta: "4 места  2.8 км",
        },
        "my-photobook": {
          status: "Закрытое тестирование в Google Play",
          platform: "Android",
          summary:
            "Мобильное приложение для фотокниг: альбомы, подписи, макеты для печати и экспорт в PDF с локальным хранением контента.",
          features: ["фотоальбомы", "экспорт PDF", "макеты для печати"],
          screenTitle: "Летний альбом",
          screenMeta: "24 фото  PDF готов",
        },
        "my-chatsense": {
          status: "Внутреннее тестирование в Google Play",
          platform: "Android",
          summary:
            "Android-приложение для выбранных WhatsApp-чатов: переводит входящие сообщения и помогает подготовить ответ на языке собеседника.",
          features: ["перевод WhatsApp-чатов", "расшифровка голоса", "11 языков"],
          screenTitle: "Переведённый чат",
          screenMeta: "11 языков  голосовой ввод",
        },
      },
    },
    projects: {
      kicker: "Web-разработка",
      title: "Web-проекты",
      description:
        "Сначала — опубликованные и текущие web-проекты. Ниже — компактный архив более ранних front-end работ.",
      currentKicker: "В разработке",
      currentTitle: "Сейчас в работе",
      currentDescription:
        "KeyLab пока находится в разработке, поэтому здесь он показан как текущая работа, а не как опубликованный сайт.",
      webKicker: "Избранная web-работа",
      webTitle: "Дипломный проект",
      webDescription:
        "Более крупный web-проект из моего front-end обучения, отделённый от небольших учебных упражнений.",
      completedTitle: "Завершённые проекты",
      archiveKicker: "Архив обучения",
      archiveTitle: "Ранние web-проекты",
      archiveDescription:
        "Небольшие учебные проекты, которые показывают мою базу: вёрстку, адаптивные страницы и практику JavaScript.",
      diplomaLabel: "Дипломный проект",
      openProject: "Открыть проект",
      viewCodeGithub: "Посмотреть код на GitHub",
      items: {
        2: { description: "Дипломный проект: интернет-магазин товаров для художественной гимнастики." },
        3: { description: "Эксперимент marketplace-интерфейса с фильтрацией товаров." },
        4: { description: "Адаптивный сайт доставки еды с ярким визуальным стилем." },
        5: { description: "Аккуратная web-верстка с адаптивной презентацией." },
        6: { description: "Страница о природе с продуманной desktop и mobile версткой." },
        9: {
          status: "Опубликованный сайт",
          tag: "Учебная платформа",
          description: "Опубликованная платформа для последовательного изучения испанского и английского языков по уровням от A0 до C1.",
          features: ["испанский и английский", "уровни A0–C1", "интерактивные уроки"],
        },
        11: {
          status: "Опубликованный сайт",
          tag: "Туристическая компания",
          description: "Многоязычный сайт туристической компании с презентацией услуг, направлений и персонального планирования поездок на испанском, русском и английском языках.",
          features: ["испанский, русский и английский", "адаптивный сайт", "светлая и тёмная темы"],
        },
        12: {
          status: "Опубликованный сайт",
          tag: "Музыкальная платформа",
          description: "Официальная музыкальная платформа IDNT с релизами, прослушиванием треков и информацией об исполнителе.",
        },
        10: {
          status: "В разработке",
          tag: "Сайт автосервиса",
          description: "Сайт для мастерской автомобильной электроники: ключи, иммобилайзеры, электронные блоки и связанные услуги.",
          features: ["автоэлектроника", "ключи и иммобилайзеры", "сервисный сайт"],
        },
      },
    },
    contact: {
      cta: {
        kicker: "Есть идея для сайта?",
        title: "От идеи до запуска",
        description:
          "Сейчас я открыт к новым web-проектам. Могу помочь пройти весь путь: продумать структуру, разработать адаптивный сайт, подготовить его к публикации, подключить домен и выполнить базовую SEO-настройку. Подробное техническое задание не обязательно — кратко опишите идею в форме ниже.",
        button: "Обсудить проект",
        servicesLabel: "Услуги web-разработки",
        services: [
          "Структура и адаптивная разработка",
          "Домен и публикация",
          "Базовая SEO-настройка и подготовка к запуску",
        ],
      },
      kicker: "Связаться",
      title: "Расскажите о вашем проекте",
      descriptionLead: "Кратко опишите идею.",
      description:
        "Через форму можно рассказать, что вы хотите создать, какие задачи должен решать сайт и какие требования уже известны.",
      placeholders: {
        name: "Имя",
        subject: "Тема",
        email: "Email",
        message: "Сообщение",
      },
      submit: "Отправить",
      sending: "Отправляю...",
      success: "Спасибо...",
      error: "Сообщение не отправлено. Подробности в консоли.",
    },
  },
};
